<div class="custom-tooltip">
	<div
		#trigger
		(click)="onTriggerClick($event)"
		(mouseenter)="onTooltipEnter()"
		(mouseleave)="onTooltipLeave()"
		class="custom-tooltip__trigger"
	>
		<ng-content select="[icon]" class="icon"></ng-content>
		<ng-content select="[text-trigger]" class="text-trigger"></ng-content>
	</div>
	<div
		#tooltip
		[class]="'custom-tooltip__container' + (containerClass ? ' ' + containerClass : '')"
		*ngIf="isTooltipHovered"
	>
		<div class="custom-tooltip__content">
			<ng-content select="[content]"></ng-content>
		</div>
	</div>
</div>
